'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.canLocalStorage = exports.removeItem = exports.setItem = exports.getItem = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _has = require('lodash/has');

var _has2 = _interopRequireDefault(_has);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// used for retrieving and setting data in web and framework through a consistent api surface
var getItem = exports.getItem = function getItem(key, self) {
	var value = void 0;

	// if self has the context of the stored value
	if ((0, _has2.default)(self, ['storage', key])) {
		return self.storage[key];
	}

	if (self.canStorage && canLocalStorage()) {
		value = JSON.parse(localStorage.getItem(key));
	} else {
		value = JSON.parse(sessionStorage.getItem(key));
	}

	// if storage is not existing then create it
	if (!(0, _has2.default)(self, ['storage'])) {
		self.storage = {};
	}

	// if it is undefined or empty then return empty
	if ((0, _isEmpty2.default)(value) || (0, _isUndefined2.default)(value)) {
		return false;
	}

	// set it on this instance
	self.storage[key] = (0, _extends3.default)({}, value);

	return value;
}; /**
    * Copyright(c) 2018, DeCurtis Corporation.All rights reserved.
    *
    * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
    *
    * File name: storage.js
    * Author   : DeCurtis Team
    * Creation Date: 27/9/18 7: 27 PM
    *
    */

var setItem = exports.setItem = function setItem(key, value, self) {
	// if storage is not existing then create it
	if (!(0, _has2.default)(self, ['storage'])) {
		self.storage = {};
	}
	// set it on this instance
	self.storage[key] = (0, _extends3.default)({}, value);
	// if storage is allowed by client only then use it
	if (self.canStorage && canLocalStorage()) {
		// set it on storage
		localStorage.setItem(key, (0, _stringify2.default)(value));
	} else {
		sessionStorage.setItem(key, (0, _stringify2.default)(value));
	}
};

var removeItem = exports.removeItem = function removeItem(key, self) {
	// if self has the context of the stored item
	if ((0, _has2.default)(self, ['storage', key])) {
		// remove it from this instance
		delete self.storage[key];
	}

	// remove it from storage
	if (self.canStorage && canLocalStorage()) {
		localStorage.removeItem(key);
	} else {
		sessionStorage.removeItem(key);
	}
};

var canLocalStorage = exports.canLocalStorage = function canLocalStorage() {
	var test = 'test';
	try {
		localStorage.setItem(test, test);
		localStorage.removeItem(test);
		return true;
	} catch (e) {
		return false;
	}
};
//# sourceMappingURL=storage.js.map